import { createAsyncThunk } from '@reduxjs/toolkit';
import userService from './UserService';
import { setKCUser } from '../App/App.slice';
import { errorHandlerThunk } from '../App/App.thunk';
import { EmailTemplate } from '../../types/emailTemplate.types';
import { updateEmailTemplate } from './UserSlice';

export const getUserSelfThunk = createAsyncThunk(
  'user/getUserSelfThunk',
  async (_: undefined, thunkAPI) => {
    try {
      const { data: user } = await userService.getSelf();
      const { data: emailTemplates } = await userService.getEmailTemplates();

      thunkAPI.dispatch(setKCUser(user.data));

      return {
        ...user.data,
        emailTemplates: emailTemplates.data,
        roles: user.data.roles?.map(
          (role: { id: number; name: string }) => role.name,
        ),
      };
    } catch (error) {
      thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const updateUserEmailTemplateThunk = createAsyncThunk(
  'user/updateUserEmailTemplateThunk',
  async (template: EmailTemplate, thunkAPI) => {
    try {
      const { data } = await userService.updateEmailTemplate(template);
      thunkAPI.dispatch(updateEmailTemplate(data.data));
    } catch (error) {
      thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

